import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { ModulesReducersEntries, Modules } from './type';
import { types } from '../actions';
import bills from './bills';
import pendingOperations from './pendingOperations';
import login from './login';
import bookings from './bookings';
import compagnies from './companies';
import pricing from './pricing';
import document from './documents';
import partners from './partners';
import drivers from './drivers';
import home from './home';
import reservations from './reservations';
import riders from './riders';
import rides from './rides';
import snappay from './snappay';
import table from './table';
import vehicles from './vehicles';
import partnerBills from './partner-bills';
import ticketing from './ticketing';
import prebooks from './prebook';
import ranks from './rank';
import viaDialog from './viaDialog';
import admin from './admin';
import marketing from './marketing';
import generic from './generic';
import errors from './errors';
import towers from './towers';
import ridesImport from './rides-import';
import driverCommunication from './driver-communication';

const modules: Modules = {
    bills,
    pendingOperations,
    login,
    bookings,
    compagnies,
    pricing,
    document,
    partners,
    drivers,
    home,
    reservations,
    riders,
    rides,
    snappay,
    table,
    vehicles,
    partnerBills,
    ticketing,
    prebooks,
    ranks,
    viaDialog,
    admin,
    marketing,
    generic,
    errors,
    towers,
    ridesImport,
    driverCommunication,
};

const modulesReducers: ModulesReducersEntries = Object.keys(modules)
    .map((key) => modules[key])
    .reduce(
        (reducersEntries, module) =>
            module.reducer
                ? {
                      ...reducersEntries,
                      [module.name]: module.reducer,
                  }
                : reducersEntries,
        {},
    );

const createRootReducer = (history) => {
    const combinedReducers = combineReducers({
        router: connectRouter(history),
        ...modulesReducers,
    });

    const rootReducer = (state, action) => {
        if (action.type === types.CLEAR_ROOT_STATE) {
            state = undefined;
        }
        return combinedReducers(state, action);
    };

    return rootReducer;
};

export default createRootReducer;
